module.exports = __webpack_public_path__ + "fonts/Barlow-Black.fbb918f0.woff";